export default __webpack_public_path__ + "static/kotlinLogo-9abc1c138f2a7e3a74fc27cbd6d7995d.png";